import { ContainerModuleLoader, withDependencies } from '@wix/thunderbolt-ioc'
import { TpaHandlerProvider, TpaHandlerProviderSymbol } from '@wix/thunderbolt-symbols'

const EditorTrackEventHandler = withDependencies(
	[],
	(): TpaHandlerProvider => ({
		getTpaHandlers() {
			return {
				trackEvent(): void {},
			}
		},
	})
)

export const editorPage: ContainerModuleLoader = (bind) => {
	bind(TpaHandlerProviderSymbol).to(EditorTrackEventHandler)
}
